import {BalanceDomino, BalanceDominoCreate, BalanceDominoUpdate} from "./@types/BalanceDomino";
export class BalanceDominoRepository {
    private httpService: IHttpService;
    private baseUrl: string;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/balance_dominos';
    }
    async getAll(): Promise<BalanceDomino[]>{
        const response = await this.httpService.get<TKResponse<BalanceDomino[]>>(this.baseUrl);
        return response.data.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    }
    async getOne(id: number): Promise<BalanceDomino> {
        const response = await this.httpService.get<TKResponse<BalanceDomino>>(`${this.baseUrl}/${id}`);
        return response.data;
    }
    async create(data: BalanceDominoCreate): Promise<BalanceDomino> {
        const response = await this.httpService.post<TKResponse<BalanceDomino>, BalanceDominoCreate>(this.baseUrl, {data});
        return response.data;
    }
    async update(id: number, data: BalanceDominoUpdate): Promise<BalanceDomino> {
        const response = await this.httpService.patch<TKResponse<BalanceDomino>, BalanceDominoUpdate>(`${this.baseUrl}/${id}`, {data});
        return response.data;
    }
    async delete(id: number): Promise<void> {
        return await this.httpService.delete(`${this.baseUrl}/${id}`);
    }
}

